import React from 'react';

import classNames from './styles.module.scss';
import LensLogo from '../Logo/LensLogo';

interface NetworkRestrictedProps {
  // Offered only when the user belongs to an organization that doesn't refuse this network.
  onSwitchOrganization?: () => void;
  onSignOut: () => void;
}

// The API refuses this organization from the network the browser is on (the network_restricted
// hold, api/common/account_policy.py). Nothing in the app can clear it — the organization decides
// — but a VPN switched on or off can, so trying again sits alongside the other ways out.
export default function NetworkRestricted({
  onSwitchOrganization,
  onSignOut,
}: NetworkRestrictedProps) {
  return (
    <div className={classNames.error}>
      <article className={classNames.networkRestricted}>
        <LensLogo noText={true} style={{height: '15rem', marginBottom: '5rem'}} />
        <h1>Not available from this network</h1>
        <p>
          Your organization only allows access to Lens from approved networks or countries, and
          you’re connecting from somewhere else. If you’re on a VPN, try turning it off or on.
          Otherwise, contact your organization’s administrator.
        </p>
        <div className={classNames.actions}>
          <button type="button" onClick={() => window.location.reload()}>
            Try again
          </button>
          {onSwitchOrganization && (
            <button type="button" onClick={onSwitchOrganization}>
              Switch organization
            </button>
          )}
          <button type="button" onClick={onSignOut}>
            Sign out
          </button>
        </div>
      </article>
    </div>
  );
}
